export default function ProgressBar({ value, color }: { value: number; color?: string }) {
  return <div className="bar-track"><i style={{ width: `${Math.max(0, Math.min(100, value))}%`, background: color }} /></div>;
}
